/* eslint-disable no-undef */
import "./modernizr"

import "./ui/core-flyd"

import "./ui/components/carousel_2"
import "./ui/components/gallery"
import "./ui/components/panelswapper"
import "./ui/components/popup"
import "./ui/components/slideshow-navigator"
import "./ui/components/slideshow_2"
import "./ui/components/tabs"
import "./ui/components/zoom"
import "./ui/components/zoom_control"
import "./ui/components/sectioned"
import "./ui/components/background_srcset"

import "./search_panel"
import "./sliding_menu"

import { Socket } from "phoenix"

import { LiveSocket } from "phoenix_live_view"

import { maybe, first } from "./ui/core/functions"

window.addEventListener("pageshow", (event) => {
  let history =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2)
  // console.log(`history:`, history)
  if (history) {
    window.location.reload()
  }
})

window.addEventListener("scroll", () => {
  // console.log(`scroll: pin header?`)
  const hash = window.location.hash
  // const has_slideshow = document.findByRole('slideshow').length > 0
  // console.log(`has_slideshow`, has_slideshow)
  if (hash === "") {
    const body = document.querySelectorAll("body")[0]
    const amount = 90
    const pin_breakpoint = 50
    if (document.scrollingElement.scrollTop > pin_breakpoint) {
      if (
        document.scrollingElement.scrollTop > amount &&
        document.scrollingElement.scrollTop > pin_breakpoint
      ) {
        body.addClass("pinned")
      } else {
        body.removeClass("pinned")
      }
    } else {
      body.removeClass("pinned")
    }
  }
})

const scrollAt = () => {
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop
  const scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight
  const { clientHeight } = document.documentElement

  return (scrollTop / (scrollHeight - clientHeight)) * 100
}
// onBeforeElUpdated
const Hooks = {}

Hooks.SearchHook = {
  // mounted() {
  //   console.log(`mounted live view: evaluate`, this.el)
  //   // UI.evaluate(this.el)
  // },
  updated() {
    // console.log(`updated`, this)
    UI.reevaluate(this.el)
  },
}

Hooks.UIHook = {
  mounted() {
    UI.evaluate(this.el)
  },
  updated() {
    UI.evaluate(this.el)
  },
}

Hooks.ScrollLock = {
  mounted() {
    document.getElementsByTagName("body")[0].addClass("no-scrolling")
    document.getElementById("navigation").addClass("hidden")
    UI.evaluate(this.el)
  },
  destroyed() {
    document.getElementsByTagName("body")[0].removeClass("no-scrolling")
    document.getElementById("navigation").removeClass("hidden")
  },
}

Hooks.AutoScroll = {
  page() {
    return parseInt(this.el.dataset.page)
  },
  fetch() {
    if (this.pending == this.page()) {
      this.pending = this.page() + 1
      this.pushEvent("load-more", {})
    }
  },
  mounted() {
    this.pending = this.page()
    let ctx = this
    window.addEventListener("scroll", (e) => {
      ctx.fetch()
    })
    this.fetch()
  },
  updated() {
    this.pending = this.page()
    if (this.el.dataset.state !== "finished") {
      this.fetch()
    }
  },
}

Hooks.InfiniteScroll = {
  page() {
    return parseInt(this.el.dataset.page)
  },
  load() {
    this.pending = this.page() + 1
    this.pushEvent("load-more", {})
  },
  mounted() {
    this.pending = this.page()
    window.addEventListener("scroll", (e) => {
      if (this.pending == this.page() && scrollAt() > 90) {
        this.load()
      }
    })
    this.load()
  },
  updated() {
    this.pending = this.page()
  },
}

Hooks.InfiniteScroll1 = {
  page() {
    return this.el.dataset.page
  },
  mounted() {
    let scrollEnded = false
    let scroll = () => {
      if (scrollEnded == false) {
        if (this.pending == this.page()) {
          this.pending = this.page() + 1
          this.pushEvent("load-more", {})
        }
      }
    }
    this.timer = setTimeout(() => scroll(), 8000)
    this.pending = this.page()

    window.addEventListener("scroll", (e) => {
      scroll()
    })
  },
  updated() {
    this.pending = this.page()
  },
}

import InfiniteScroll3 from "./infinite_scroll"
Hooks.InfiniteScroll3 = InfiniteScroll3

import PageScroll from "./page_scroll"
Hooks.PageScroll = PageScroll

import InfiniteScroll2 from "./infinite_scroll_2"
Hooks.InfiniteScroll2 = InfiniteScroll2

Hooks.ProductScroll = {
  mounted() {
    window.addEventListener("keydown", (ev) => {
      const rect = this.el.getBoundingClientRect()
      const overlap = 300
      if (["ArrowLeft", "ArrowRight"].contains(ev.key)) {
        if (rect.top < window.innerHeight + overlap) {
          this.pushEvent("scroll_panel", { key: ev.key })
        }
      }
    })
  },
}

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content")

// let liveSocket = new LiveSocket("/live", Socket, {
//   params: {
//     _csrf_token: csrfToken,
//   },
//   hooks: Hooks,
//   dom: {
//     onBeforeElUpdated(from, to){
//       console.log(`updating dom: from:`, from)
//       console.log(`updating dom: to:`, to)
//     }
//   }
// })

const socket = new Socket("/socket", {
  params: {},
})

socket.connect()
window.socket = socket

window.addEventListener("load", () => {
  const csrfToken = document
    .querySelector("meta[name='csrf-token']")
    .getAttribute("content")

  const liveSocket = new LiveSocket("/live", Socket, {
    params: {
      _csrf_token: csrfToken,
    },
    hooks: Hooks,
    dom: {
      onBeforeElUpdated(from, to) {
      if (from.dataset.restoreClasses != null) {
        to.classList = from.classList
      }
        // const canvas = first(document.findByRole("carousel-frame"))
        // if (canvas != null) {
        //   console.log()
        // }
        // if (from.dataset.role != null) {
        //   console.log(`role: ${from.dataset.role}`, from.dataset, from)
        // }

        if (from.dataset.role === "carousel-frame") {
            // console.log(`update carousel-frame dom?: ${from.dataset.scrollLeft} ${from.scrollLeft}`, from)
            // to.scrollLeft = from.dataset.scrollLeft
        }

        if (from.dataset.resetDom != null) {
    //       // from.scrollLeft
    //       // console.log(`update dom?: from:`, from.scrollLeft)

          if (from.dataset.scrollLeft != null) {
            // console.log(`reset scrollLeft: ${from.dataset.scrollLeft}`)
            // to.dataset.scrollLeft = from.dataset.scrollLeft
            // to.scrollLeft = from.dataset.scrollLeft
          }
    //       // if (from.scrollLeft > 0) {
    //       //   console.log(`updating dom: from:`, from.scrollLeft)
    //       //   console.log(`updating dom: to:`, to.scrollLeft)
    //       // }
    //       // to.scrollLeft = from.scrollLeft
        }

        if (from.dataset.scrollLeft != null) {
          // console.log(`reset scrollLeft: ${from.dataset.scrollLeft}`)
          to.scrollLeft = from.dataset.scrollLeft
  //       //   to.dataset.scrollLeft = from.dataset.scrollLeft
  //       //   to.scrollLeft = from.dataset.scrollLeft
        }

      },
    },
  })

  liveSocket.connect()
  window.liveSocket = liveSocket
})

window.addEventListener("load", () => {
  const hash = window.location.hash
  const has_slideshow = document.findByRole("slideshow").length > 0
  // console.log(`has_slideshow`, has_slideshow)
  if (hash !== "" && has_slideshow == true) {
    // console.log(`scrolling to location hash`)
    maybe((el) => el.scrollIntoView({ behavior: "smooth" }))(
      document.querySelector(hash)
    )
  }
})

// import "./graph"
